import React, { useEffect, useState, useRef } from 'react';
import PropTypes, { checkPropTypes } from 'prop-types';
import {
  addIframeClickListeners,
  removeIframeClickListeners
} from '../../../modules/core/services/coreIFrameHelper';
import { StyledDrawer } from './controlPanelStyles';

/**
 *  Component for Control Panel slider.
 *
 */
function ControlPanelSlider(props) {
  const {
    children = defaultProps.children,
    openControlMenu = defaultProps.openControlMenu,
    closeCallback = defaultProps.closeCallback,
    disabled = defaultProps.disabled
  } = props;
  checkPropTypes(ControlPanelSlider.propTypes, props, 'prop', ControlPanelSlider.name);
  const [openSlider, setOpenSlider] = useState(false);
  const wrapperRef = useRef(null);

  const clickofmenu = () => {
    setOpenSlider(false);
    closeCallback();
  };

  const handleOutsideClick = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event?.target) && openSlider) {
      clickofmenu();
    }
  };

  useEffect(() => {
    if (!disabled) {
      setOpenSlider(openControlMenu);
    }
  }, [openControlMenu, disabled]);

  useEffect(() => {
    if (openSlider && !disabled) {
      document.addEventListener('mousedown', handleOutsideClick, false);
      addIframeClickListeners(handleOutsideClick);
      return () => {
        document.removeEventListener('mousedown', handleOutsideClick, false);
        removeIframeClickListeners();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openSlider, disabled]);

  return (
    <div ref={wrapperRef}>
      <StyledDrawer
        id="control-panel-expanded-view"
        anchor="left"
        open
        variant="persistent"
        sliderOpen={openSlider}
      >
        {children}
      </StyledDrawer>
    </div>
  );
}

// PropType check
ControlPanelSlider.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Prop to open the control slider.
   */
  openControlMenu: PropTypes.bool,
  /**
   * Close call back.
   */
  closeCallback: PropTypes.func,
  /**
   * Disable the control panel slider.
   */
  disabled: PropTypes.bool
};

const defaultProps = {
  children: null,
  openControlMenu: false,
  closeCallback: () => {},
  mouseLeaveCallback: undefined,
  disabled: false
};

export default ControlPanelSlider;
